/*jshint esversion: 6 */
/*jshint sub:true*/
// import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  new_wp_position: false,
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getTrainsBacklogs: (state, getters, rootState) => (project_id) => {
    return rootState.Ultra.projects[project_id].trainsbacklogs.map(trainsbacklog => rootState.Ultra[trainsbacklog.type][trainsbacklog.id]);
  },
  getHistTrainsBacklogs: (state, getters, rootState) => (project_id) => {
    return rootState.Ultra.histprojects[project_id].histtrainsbacklogs.map(trainsbacklog => rootState.Ultra[trainsbacklog.type][trainsbacklog.id]);
  },
  getWBWorkpackagesForTaktplan: (state, getters, rootState, rootGetters) => (payload) => {


    let sort_fn = function(a,b) {
      if (a.position > b.position) {
        return 1;
      }
      if (a.position < b.position) {
        return -1;
      }
      // if position is equal sort by length
      if (a.length > b.length) {
        return -1;
      }
      if (a.length < b.length) {
        return 1;
      }
      return 0;
    };
    // console.log('-------------start-------------');
    let wbworkpackages;
    if (payload.hist) {
      wbworkpackages = JSON.parse(JSON.stringify(rootGetters['Ultra/getUObjects']({type: 'histwbworkpackages', ids: payload.wbline.histwbworkpackages}).filter(wp => wp.position !== -1).sort(sort_fn)));
    } else {
      wbworkpackages = JSON.parse(JSON.stringify(rootGetters['Ultra/getUObjects']({type: 'wbworkpackages', ids: payload.wbline.wbworkpackages}).filter(wp => wp.position !== -1).sort(sort_fn)));
    }
    //handle overlapping;
    let used_positions = {};
    let used_y_index_in_position = {};
    let max_y_index = 1;
    wbworkpackages.forEach(wp => {
      for (var i = wp.position; i < wp.position+wp.length; i++) {
        if (used_positions[i]) {
          used_positions[i].push(wp.id);
          //handle y_index
          if (i === wp.position) {
            for (var j = 0; j < used_positions[i].length; j++) {
              if (!used_y_index_in_position[i].includes(j)) {
                wp.y_index = j;
                if (j > max_y_index) {
                  max_y_index = j;
                }
                break;
              }
            }
          }
          used_y_index_in_position[i].push(wp.y_index);
          //handle height
          if (used_positions[i].length === 2) {
            wbworkpackages.find(wp => wp.id === used_positions[i][0]).height = 0.5;
          }
          wp.height = 0.5;
        } else {
          if (i === wp.position) {
          wp.y_index = 0;
          wp.height = 1;
          }
          used_positions[i] = [wp.id];
          used_y_index_in_position[i] = [wp.y_index];
        }
      }
    });
    // console.log('-------------end-------------');
    return {wbworkpackages: wbworkpackages, max_y_index: max_y_index};
  },
};
// Actions
const actions = {
  setNewWPPosition({commit}, position) {
    commit('set_new_wp_position', position);
  },
};
// Mutations
const mutations = {
  set_new_wp_position(state, position) {
    state.new_wp_position = position;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
